export interface IGSTData {
    dealershipName: string;
    gstType: string;
    gstNumber: string;
    panNumber: string;
    panUrl: string;
}

export interface IGstDropDown {
    value: string;
    displayValue: string;
}

export const GSTTypes: IGstDropDown[] = [
    {
        value: 'regular',
        displayValue: 'Regular',
    },
    {
        value: 'composite',
        displayValue: 'Composite',
    },
];

export const gstNumberRegex =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

export enum GSTDetailsFormState {
    INITATED,
    COMPLETED,
    FAILED,
}
